import { AGENDA_SIDEPANEL_ACTIONS } from './actions';

export default function AgendaSidePanelContextReducer(state, action) {
  const { type, payload } = action;

  switch (type) {
    case AGENDA_SIDEPANEL_ACTIONS.OPEN_SIDEPANEL: {
      const { agendaId, agendaText, checkInInstanceId, checkInParentId, filterEmpIds } = payload;

      return {
        ...state,
        isOpen: true,
        agendaId,
        agendaText,
        checkInInstanceId,
        checkInParentId,
        filterEmpIds,
      };
    }
    case AGENDA_SIDEPANEL_ACTIONS.CLOSE_SIDEPANEL: {
      return {
        ...state,
        isOpen: false,
        agendaId: null,
        agendaText: '',
        checkInInstanceId: null,
        checkInParentId: null,
        filterEmpIds: [],
        closedCount: state.closedCount + 1,
      };
    }

    default:
      return state;
  }
}
